export const MRT_CONTEXT_BASEPATH = '/mobify/mrt'
export const MRT_API_BASEPATH = MRT_CONTEXT_BASEPATH + '/api'
export const MAX_CACHE_AGE = 60 * 15 // 15 min
export const MAX_CACHE_AGE_SEARCH = 60 * 3 // 3 min

export const QUERY_PARAMS_EXCLUSIONS = [
    '_gl',
    'ad_id',
    'adfcd',
    'awc',
    'brid',
    'c_id',
    'campaign_id',
    'changeCountry',
    'clickId',
    'cluid',
    'cto_pld',
    'dclid',
    'dctx',
    'et_rid',
    'fbclid',
    'gad',
    'gad_campaignid',
    'gad_source',
    'gbraid',
    'gclid',
    'gclsrc',
    'gtm_latency',
    'hgtid',
    'j',
    'jb',
    'l',
    'mid',
    'mp-ble-nbc',
    'msclkid',
    'pageName',
    'sa',
    'sfmc_activityid',
    'sfmc_id',
    'sfmc_sub',
    'sfnsn',
    'source',
    'srsltid',
    'sv1',
    'sv_campaign_id',
    'tduid',
    'trlid',
    'ttclid',
    'u',
    'usg',
    'ust',
    'utm-content',
    'utm_campaign',
    'utm_content',
    'utm_id',
    'utm_medium',
    'utm_parameters',
    'utm_source',
    'utm_term',
    'wbraid',
]
